
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    idTransacao: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      totalTimeInSeconds: 50,
      currentTimeInSeconds: 50,
      interval: null,
      isTimerActive: false,
      dialogStatusPayment: false,
      loadingBtn: false,
      restartCount: 0,
      maxRestarts: 180,
    }
  },
  computed: {
    ...mapGetters('sdagenda', ['sdagenda']),
    ...mapGetters('payment-safe2pay', ['allStatusPayment']),
    ...mapGetters('unidade', ['unidadeInformation']),
    progressPercentage() {
      return (this.currentTimeInSeconds / this.totalTimeInSeconds) * 100
    },
    formattedTime() {
      const minutes = Math.floor(this.currentTimeInSeconds / 60)
      const seconds = this.currentTimeInSeconds % 60
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    },
  },
  beforeDestroy() {
    this.stopTimer()
  },
  mounted() {
    this.startTimer()
    this.verifysdagenda()
  },
  methods: {
    ...mapActions('payment-safe2pay', ['statusPayment']),
    ...mapActions('dataClient', [
      'adicionarCartClient',
      'cleanClient',
      'fullyCleanCart',
    ]),
    ...mapActions('sdagenda', ['verifysdagenda']),
    ...mapMutations('cart', ['CLEAN_CART']),
    startTimer() {
      if (!this.isTimerActive) {
        this.isTimerActive = true
        this.interval = setInterval(this.updateTimer, 1000)
      }
    },
    stopTimer() {
      clearInterval(this.interval)
      this.isTimerActive = false
    },
    resetTimer() {
      this.stopTimer()
      this.currentTimeInSeconds = this.totalTimeInSeconds
      this.restartCount += 1

      if (this.restartCount < this.maxRestarts) {
        this.startTimer()
      } else {
        this.$router.push('/')
        this.$toast.error('Tempo para pagar pix encerrou.')
      }
    },
    updateTimer() {
      if (this.currentTimeInSeconds > 0) {
        this.currentTimeInSeconds -= 1
      } else {
        this.stopTimer()
        this.onTimerEnd()
      }
    },
    async onTimerEnd() {
      const idTransacao = this.idTransacao
      const vendedor = this.unidadeInformation.cpfcnpj
      try {
        await this.statusPayment({ idTransacao, vendedor })
        const status = this.allStatusPayment.status
        if (status === 'Autorizado') {
          this.dialogStatusPayment = true
          this.CLEAN_CART()
        } else if (status === 'Pendente') {
          this.resetTimer()
        } else if (status === 'Recusado') {
          this.$router.push('/')
          this.$toast.error('pagamento recusado')
          this.cleanClient()
        }
      } catch (error) {
        console.error(error)
        this.$toast.error('houve algum erro: ' + error)
      }
    },
    async verifyPayment() {
      const idTransacao = this.idTransacao
      const vendedor = this.unidadeInformation.cpfcnpj

      this.loadingBtn = true
      try {
        await this.statusPayment({ idTransacao, vendedor })
        const status = this.allStatusPayment.status
        if (status === 'Autorizado') {
          this.dialogStatusPayment = true
          this.CLEAN_CART()
        } else if (status === 'Pendente') {
          this.$toast.warning('Pagamento ainda pendente')
        } else if (status === 'Recusado') {
          this.$router.push('/')
          this.$toast.error('pagamento recusado')
          this.cleanClient()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loadingBtn = false
      }
    },
    Scheduling() {
      this.$router.push({
        path: '/agendamento',
        query: {
          idTransacao: this.idTransacao,
        },
      })
    },
    shedulingAfter() {
      this.$router.push('/')
      this.fullyCleanCart()
    },
  },
}
